import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectUserCreateStatus = createSelector(
  [(store: RootState) => store.userCreate.createStatus],
  (status) => status
);
